import { AppBar, Toolbar, Typography } from '@mui/material';
import React, { useContext } from 'react';
import UPShowLogo from '../assets/UPshow_logo_primary.svg';
import { RemoteControlContext } from '../ContextProvider';

export default function NavbarHeader () {
    const { currentOrg } = useContext(RemoteControlContext);
    return (
        <AppBar position='static'>
            <Toolbar>
                <img className='img-logo' src={UPShowLogo} alt='UPShow logo' />
                <div className='managing-org'>
                    <Typography variant='header-text' align='right'>You are managing</Typography>
                    <Typography variant='header-text' align='right'><strong>{currentOrg.name}</strong></Typography>
                </div>
            </Toolbar>
        </AppBar>
    );
}
